module.exports = __webpack_public_path__ + "static/media/bootstrap4_logo.ffded238.svg";